import React, { useState, useEffect } from 'react';
import { useCart } from '../contexts/CartContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const AddToCartButton = ({
  product,
  quantity = 1,
  note = '',
  children = 'Add to Cart',
  className = '',
  style = {},
  onClose = () => {},
  disabled = false,
  setShowPartnerDialog,

}) => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthenticated = () => !!localStorage.getItem('userEmail');
  const isOutOfStock = product && (product.inStock === false || product.inStock === 'false');

  console.log('[AddToCartButton] product:', product);
  
  const handleAddToCart = async () => {
    const productObject = {
      ...product,
      //partner_id: 15, // Hardcoded for testing (use product.partner_id in production)
      quantity,
      note,
    };
    
    if (isAuthenticated()) {
      const result = await addToCart(productObject);
      
      if (result?.isNewPartner) {
        console.log('[AddToCartButton] New partner detected:');
        setShowPartnerDialog(true); 
         
      }
      onClose();
    } else {
      const postLoginRedirect = {
        from: 'EPharmacy',
        action: 'addToCart',
        product: productObject,
      };
      localStorage.setItem('postLoginRedirect', JSON.stringify(postLoginRedirect));
      localStorage.setItem('signInMessage', 'Please sign in to add this product to your cart.');
      navigate('/signIn', {
        state: { from: location },
        replace: true,
      });
    }
  };

  

  return (
    <>
      <button
        type="button"
        className={`add-to-cart-button ${className}`.trim()}
        style={{
         
          ...style,
          ...(isOutOfStock ? {
            backgroundColor: '#e0e0e0',
            color: '#bdbdbd',
            cursor: 'not-allowed',
            opacity: 0.7,
            border: '2px solid #cccccc',
            boxShadow: 'none',
          } : {})
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleAddToCart();
        }}
        disabled={disabled || isOutOfStock}
      >
        {isOutOfStock ? 'Out of stock' : children}
      </button>

      
    </>
  );
};

export default AddToCartButton;